<template>
    <div class="bg-white rounded">
        <div class="table pt-3 mb-0">
            <div class="add_license d-flex justify-content-between align-items-center flex-wrap mb-3 px-3">
                <h3 class="font-weight-bold f-20 text-left mb-0 text-black">{{ $t('webhooks.title') }}</h3>
                <b-button @click="$bvModal.show('webhook-modal')"
                    class="export equipment d-flex justify-content-center align-items-center w-fit-content"
                    variant="primary">
                    <b-icon icon="plus" class="p-0" aria-hidden="true"></b-icon>
                    <p class="mb-0 ml-2 text-white p-0">{{ $t('webhooks.addWebhook') }}</p>
                </b-button>
            </div>
            <v-app class="webhooks-table-wrapper">
            <b-table :sticky-header="'calc(100vh - 273px)'" responsive :fields="translatedFields" :items="items" hover
                :per-page="perPage" :current-page="currentPage" show-empty class="px-0 py-0">
                 <template #cell(events)="data">
                    <div v-if="data.value.length" class="d-flex align-items-center">
                        <div class="table-tags mr-2">{{updateEventLabel(data.value[0].event) }}</div>
                        <v-tooltip bottom v-if="data.value.length > 1">
                            <template #activator="{ on, attrs }">
                                <div class="table-tags" v-on="on" v-bind="attrs">+{{ data.value.length - 1 }}</div>
                            </template> <span v-html="data.value.slice(1).map(tag => updateEventLabel(tag.event)).join('<br>')"></span>
                        </v-tooltip>
                    </div>
                    <p class="mb-0" v-else>-</p>
                </template>
                 <template #cell(doc_types)="data">
                    <div v-if="data.value.length" class="d-flex align-items-center">
                        <div class="table-tags mr-2">{{ data.value[0].type }}</div>
                        <v-tooltip bottom v-if="data.value.length > 1">
                            <template #activator="{ on, attrs }">
                                <div class="table-tags" v-on="on" v-bind="attrs">+{{ data.value.length - 1 }}</div>
                            </template> <span v-html="data.value.slice(1).map(tag => tag.type).join('<br>')"></span>
                        </v-tooltip>
                    </div>
                    <p class="mb-0" v-else>-</p>
                </template>
                <template #cell(action)="data">
                    <div>
                        <svg @click="editWebhookItem(data.item)" class="mr-4 cursor-pointer" width="18" height="18"
                            viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path
                                d="M5.52719 16.7477L14.5274 7.74753L10.2525 3.4726L1.25226 12.4728C1.12836 12.5969 1.04034 12.7522 0.997548 12.9222L0 18L5.07684 17.0025C5.2473 16.9598 5.40322 16.8717 5.52719 16.7477V16.7477ZM17.4329 4.84205C17.796 4.47881 18 3.98622 18 3.4726C18 2.95898 17.796 2.46639 17.4329 2.10315L15.8968 0.567123C15.5336 0.203994 15.041 0 14.5274 0C14.0138 0 13.5212 0.203994 13.1579 0.567123L11.6219 2.10315L15.8968 6.37808L17.4329 4.84205Z"
                                fill="#2CCE89" />
                        </svg>
                        <svg @click="showWebhookDeletePopup(data.item.id)" class="cursor-pointer" width="19" height="20"
                            viewBox="0 0 19 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M1 5.15704H17.6139" stroke="#FF0000" stroke-width="1.5" stroke-linecap="round"
                                stroke-linejoin="round" />
                            <path
                                d="M3.0766 5.15704H15.537V17.6175C15.537 17.9846 15.3911 18.3368 15.1315 18.5964C14.8719 18.856 14.5197 19.0019 14.1525 19.0019H4.46109C4.0939 19.0019 3.74175 18.856 3.4821 18.5964C3.22247 18.3368 3.0766 17.9846 3.0766 17.6175V5.15704Z"
                                stroke="#FF0000" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                            <path
                                d="M5.84607 5.15347V4.46123C5.84607 3.54325 6.21073 2.66287 6.85984 2.01377C7.50894 1.36466 8.38932 1 9.3073 1C10.2253 1 11.1057 1.36466 11.7548 2.01377C12.4039 2.66287 12.7685 3.54325 12.7685 4.46123V5.15347"
                                stroke="#FF0000" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                            <path d="M7.23175 9.3065V14.8466" stroke="#FF0000" stroke-width="1.5" stroke-linecap="round"
                                stroke-linejoin="round" />
                            <path d="M11.385 9.3065V14.8466" stroke="#FF0000" stroke-width="1.5" stroke-linecap="round"
                                stroke-linejoin="round" />
                        </svg>
                    </div>
                </template>
            </b-table>
            </v-app>
            <div class="entries-pagination px-0 px-sm-2">
                <div class="d-flex align-items-center flex-wrap">
                    <div class="text-left show-entries mr-md-3 pl-3 pl-md-0 ml-md-0">
                        <b-form-select v-model="perPage" :options="pageOptions" />
                    </div>
                    <div class="pagination">
                        <b-pagination v-model="currentPage" :total-rows="rows" :per-page="perPage"
                            aria-controls="my-table"></b-pagination>
                    </div>
                    <p class="my-0 pr-3 pr-md-0 mr-md-1 mt-0 f-14">
                        {{ positionText }}
                    </p>
                </div>
            </div>
        </div>
        <b-modal id="webhook-modal" centered no-close-on-backdrop :footer-class="'d-block p-3 m-0'"
            :body-class="'equipment-edit-modal'" no-close-on-esc>
            <template #modal-header="{ close }">
                <h5 class="modal-title">
                    {{ editWebhook ? $t('webhooks.editWebhook') : $t('webhooks.addWebhook') }}
                </h5>
                <b-button size="sm" class="d-none" variant="outline-danger" @click="close()">
                    Close Modal
                </b-button>
            </template>
            <div class="body">
                <b-row>
                    <b-col sm="12" class="mt-3">
                        <b-form-group :label="$t('webhooks.nameLabel')" class="text-left mb-0">
                            <b-form-input v-model="payload.name" :placeholder="$t('webhooks.namePlaceholder')" class="unit"
                                required></b-form-input>
                            <p v-if="errors && errors.name" class="field-error mb-lg-3">
                                {{ errors.name[0] }}
                            </p>
                        </b-form-group>
                    </b-col>
                    <b-col sm="12" class="mt-3">
                        <b-form-group :label="$t('webhooks.typeLabel')" class="text-left mb-0">
                            <b-form-select v-model="payload.type" @change="payload.email = null; payload.webhook_url = null"
                                :options="typeSelectOptions" class="unit f-12" required />
                            <p v-if="errors && errors.type" class="field-error mb-lg-3">
                                {{ errors.type[0] }}
                            </p>
                        </b-form-group>
                    </b-col>
                    <b-col sm="12" class="mt-3" v-if="payload.type === 'email'">
                        <b-form-group :label="$t('webhooks.emailLabel')" class="text-left mb-0">
                            <b-form-input v-model="payload.email" :placeholder="$t('webhooks.emailPlaceholder')" class="unit f-12"
                                required></b-form-input>
                            <p v-if="errors && errors.email" class="field-error mb-lg-3">
                                {{ errors.email[0] }}
                            </p>
                        </b-form-group>
                    </b-col>
                    <b-col sm="12" class="mt-3" v-if="payload.type === 'url'">
                        <b-form-group :label="$t('webhooks.urlLabel')" class="text-left mb-0">
                            <b-form-input v-model="payload.webhook_url" :placeholder="$t('webhooks.urlPlaceholder')" class="unit f-12"
                                required></b-form-input>
                            <p v-if="errors && errors.webhook_url" class="field-error mb-lg-3">
                                {{ errors.webhook_url[0] }}
                            </p>
                        </b-form-group>
                    </b-col>
                    <b-col sm="12" class="mt-3">
                        <div class="text-left mb-0">
                            <label class="state">{{ $t('webhooks.eventsLabel') }}</label>
                            <v-select class="f-12" multiple :options="translatedEventOptions" :reduce="(option) => option.id"
                                v-model="payload.events">
                                <span slot="no-options">
                                    {{ $t('webhooks.searchName') }}
                                </span>
                            </v-select>
                            <p v-if="errors && errors.events" class="field-error pb-4">
                                {{ errors.events[0] }}
                            </p>
                        </div>
                    </b-col>
                    <!-- Doc types narrow a document event; nothing else they can
                         apply to, so the field only appears with one picked. -->
                    <b-col sm="12" class="mt-3" v-if="hasDocumentEvent">
                        <div class="text-left mb-0">
                            <label class="state">{{ $t('webhooks.docTypeLabel') }}</label>
                            <v-select class="f-12" multiple :options="docTypeOptions" :reduce="(option) => option.id"
                                @search="searchDocType" v-model="payload.doc_types">
                                <span slot="no-options">
                                    {{ $t('webhooks.searchName') }}
                                </span>
                            </v-select>
                            <p v-if="errors && errors.doc_types" class="field-error pb-4">
                                {{ errors.doc_types[0] }}
                            </p>
                        </div>
                    </b-col>
                </b-row>
            </div>
            <template #modal-footer>
                <div class="text-right modal-footer border-0 p-0 mb-0 mt-0">
                    <b-button class="mx-0 h-40px w-100px m-0 mr-3" @click="resetForm()"
                        variant="secondary">{{ $t('webhooks.cancel') }}</b-button>
                    <div class="d-flex align-items m-0">
                        <b-button class="mx-0 mb-0 h-40px w-100px m-0" variant="primary"
                            @click="updateWebhookData()">{{ $t('webhooks.save') }}</b-button>
                    </div>
                </div>
            </template>
        </b-modal>
        <DeleteModal v-if="showDeletePopup" @confirm="deleteItem($event)" />
    </div>
</template>
<script>
import { mapGetters, mapActions } from "vuex";
import DeleteModal from "@/components/DeleteModal.vue";
import vSelect from "vue-select";
import "vue-select/dist/vue-select.css";
import { checkEmail, checkUrlFormat } from "@/services/helper";
export default {
    name: "WebhooksSection",
    components: { DeleteModal, vSelect },
    data() {
        return {
            items: [],
            checkEmail,
            checkUrlFormat,
            editWebhook: false,
            perPage: 50,
            currentPage: 1,
            webhookID: null,
            emptyTable: false,
            showDeletePopup: false,
            docTypeOptions: [],
            eventKeyMap: {
                'driver.created': 'webhooks.eventDriverCreated',
                'driver.updated': 'webhooks.eventDriverUpdated',
                'driver.deleted': 'webhooks.eventDriverDeleted',
                'vehicle.created': 'webhooks.eventVehicleCreated',
                'vehicle.updated': 'webhooks.eventVehicleUpdated',
                'vehicle.deleted': 'webhooks.eventVehicleDeleted',
                'trailer.created': 'webhooks.eventTrailerCreated',
                'trailer.updated': 'webhooks.eventTrailerUpdated',
                'trailer.deleted': 'webhooks.eventTrailerDeleted',
                'document.created': 'webhooks.eventDocumentCreated',
                'document.updated': 'webhooks.eventDocumentUpdated',
                'document.deleted': 'webhooks.eventDocumentDeleted',
                'dvir.submitted': 'webhooks.eventDvirSubmitted',
                'form.submitted': 'webhooks.eventFormSubmitted',
            },
            pageOptions: [
                {
                    value: 10,
                    text: "10",
                },
                {
                    value: 25,
                    text: "25",
                },
                {
                    value: 50,
                    text: "50",
                },
                {
                    value: 100,
                    text: "100",
                },
            ],
            errors: {},
            payload: {
                name: null,
                type: 'url',
                email: null,
                webhook_url: null,
                doc_types: [],
                events: []
            },
        }
    },
    watch: {
        // Dropping the document events drops what was narrowing them, so a
        // hidden field cannot be saved with the webhook.
        hasDocumentEvent(hasDocument) {
            if (!hasDocument) this.payload.doc_types = [];
        },
    },
    computed: {
        ...mapGetters([ "userCompany"]),
        translatedFields() {
            return [
                { key: "name", label: this.$t('webhooks.nameColumn'), sortable: true, stickyColumn: true, thClass: 'font-table-weight-bold' },
                { key: "email_url", label: this.$t('webhooks.emailUrlColumn'), sortable: true, thClass: 'font-table-weight-bold' },
                { key: "events", label: this.$t('webhooks.eventsColumn'), sortable: true, thClass: 'font-table-weight-bold' },
                { key: "doc_types", label: this.$t('webhooks.docTypesColumn'), sortable: true, thClass: 'font-table-weight-bold' },
                { key: "Action", sortable: true, thClass: 'font-table-weight-bold' },
            ];
        },
        // "document.created" and the rest of that family; anything else takes the
        // webhook as it is.
        hasDocumentEvent() {
            return (this.payload.events || []).some((event) => `${event}`.includes('document'));
        },
        translatedEventOptions() {
            return Object.keys(this.eventKeyMap).map(id => ({ id, label: this.$t(this.eventKeyMap[id]) }));
        },
        typeSelectOptions() {
            return [
                { value: 'url', text: this.$t('webhooks.typeUrl') },
                { value: 'email', text: this.$t('webhooks.typeEmail') },
            ];
        },
        rows() {
            return this.items.length;
        },
        positionText() {
            const endIndex = this.currentPage * this.perPage;
            const startIndex = this.rows > 0 ? (this.currentPage - 1) * this.perPage + 1 : 0;
            const end = endIndex > this.rows ? this.rows : endIndex;
            return this.$t('webhooks.positionText', { start: startIndex, end, total: this.rows });
        }
    },
    methods: {
        ...mapActions(['getAllDocTypes', 'getAllWebhooks', "deleteWebhook", "setNotification", "updateWebhook", "addWebhook", "setLoader"]),
        updateEventLabel(label) {
            return this.eventKeyMap[label] ? this.$t(this.eventKeyMap[label]) : label;
        },
        checkNullValues(payload) {
            let nullKeys = [];
            for (let [key, value] of Object.entries(payload)) {
                if (!value) {
                    nullKeys.push(key);
                }
            }
            return nullKeys;
        },
        async searchDocType(searchText) {
            if (searchText) {
                let options = [];
                const data = await this.getAllDocTypes(`search=${searchText}`);
                data.forEach((x) => {
                    options.push({
                        id: x.id,
                        label: x.type,
                    });
                });
                this.docTypeOptions = this.docTypeOptions.concat(options)
                this.docTypeOptions = [...new Map(this.docTypeOptions.map(item => [item['id'], item])).values()]
            }
        },
        async deleteItem(status) {
            if (status) {
                try {
                    await this.deleteWebhook(`${this.webhookID}/?company_id=${this.userCompany}`)
                    await this.setNotification({
                        msg: this.$t('webhooks.webhookDeleted'),
                        type: "success",
                        color: "green",
                    });
                    this.webhookID = null
                    this.showDeletePopup = false;
                    await this.getWebhooks()
                }
                catch (error) {
                    this.webhookID = null
                    this.showDeletePopup = false;
                    if (typeof error === "object" && error.error) {
                        await this.setNotification({
                            msg: error.error,
                            type: "error",
                            color: "red",
                        });
                    }
                }
            }
            else this.showDeletePopup = false
        },
        showWebhookDeletePopup(id) {
            this.showDeletePopup = true;
            this.webhookID = id;
        },
        editWebhookItem(data) {
            const eventIds = Object.keys(this.eventKeyMap);
            const foundEvents = eventIds.filter(id => data.events.some(e => e.event === id));
            this.docTypeOptions = data.doc_types.map(type => {
                return{ id: type.id, label: type.type };
            });
            this.payload = {
                id: data.id,
                name: data.name,
                type: this.checkEmail(data.email_url) ? 'email' : 'url',
                email:  this.checkEmail(data.email_url) && data.email_url ? data.email_url : null,
                webhook_url: !this.checkEmail(data.email_url) && data.email_url ? data.email_url : null,
                doc_types: data.doc_types.map(x => x.id),
                events: foundEvents
            }
            this.editWebhook = true
            this.$bvModal.show('webhook-modal')
        },
        async getWebhooks() {
            const { data } = await this.getAllWebhooks(this.userCompany);
            this.items = [];
            data.map((item) => {
                this.items.push({
                    id: item.id,
                    name: item.name,
                    email_url: item.email || item.webhook_url,
                    doc_types: item.doc_types,
                    events: item.events,
                })
            })
        },
        resetForm() {
            this.errors = {}
            this.$bvModal.hide('webhook-modal')
            this.webhookID = null
            this.editWebhook = false
            this.payload = {
                name: null,
                type: 'url',
                email: null,
                webhook_url: null,
                doc_types: [],
                events: []
            }
        },
        async updateWebhookData() {
            try {
                if (this.payload.type === 'email' &&this.payload.email) {
                    if (!this.checkEmail(this.payload.email)) {
                        throw {
                            email: [this.$t('webhooks.wrongFormat')],
                        };
                    }
                }
                if(this.payload.webhook_url){
                    if(!this.checkUrlFormat(this.payload.webhook_url)){
                        throw {
                            webhook_url: [this.$t('webhooks.wrongFormat')],
                        };
                    }
                }
                const nullKeys = this.checkNullValues({
                    name: this.payload.name,
                    ...(this.payload.type === 'url' ? { webhook_url: this.payload.webhook_url } : { email: this.payload.email }),
                    events: this.payload.events.length > 0 ? this.payload.events : null
                });
                if (nullKeys.length === 0) {
                    this.setLoader(true);
                    if(this.editWebhook){
                        await this.updateWebhook({ id: this.payload.id, payload:{...this.payload, company_id: this.userCompany } });
                    }
                    else await this.addWebhook({ ...this.payload, company_id: this.userCompany });
                    await this.getWebhooks();
                    await this.setNotification({
                        msg: this.editWebhook ? this.$t('webhooks.webhookUpdated') : this.$t('webhooks.webhookAdded'),
                        type: "success",
                        color: "green",
                    });
                    this.resetForm();
                    this.setLoader(false);
                }
                else {
                    let error = {};
                    nullKeys.forEach((x) => {
                        error[x] = [this.$t('webhooks.fieldRequired')];
                    });
                    throw error;
                }
            }
            catch (error) {
                this.setLoader(false);
                if (typeof error === "object") {
                    this.errors = error;
                }
            }
        },
    },
    async mounted() {
        this.getWebhooks();
    }
}
</script>
<style scoped>
.webhooks-table-wrapper {
    background: transparent;
}
.webhooks-table-wrapper >>> .v-application--wrap {
    min-height: auto;
}
</style>